export enum MaxLength {
    MOBILE_PHONE = '12',
}
  